import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { useUser } from 'contexts/UserContext';

const guardMeLoggedIn = () => {
  const { isLoading, me } = useUser();
  const router = useRouter();

  useEffect(() => {
    if (!isLoading && !me) {
      router.replace('/logga-in');
    }
  }, [isLoading, me, router]);

  return { meLoading: isLoading || !me };
};

export default guardMeLoggedIn;
